
import { getDailyNoShowData, getDailyNoShowFilters } from '../api.js'

import settings from '../settings.js'
import pageApiData from '../utils/pageApiData.js'

const [ _getDailyNoShowDataFromServer, _getDailyNoShowData, _getDailyNoShowDataSync ] = pageApiData.createFunctions(getDailyNoShowData)
const [ _getDailyNoShowFiltersFromServer, _getDailyNoShowFilters, _getDailyNoShowFiltersSync ] = pageApiData.createFunctions(getDailyNoShowFilters)

function getNumPerPage() {
  return settings.dailyNoShowList.numPerPage
}

function getCurrentPage() {
  return settings.dailyNoShowList.currentPage
}

function setCurrentPage(pageNumber) {
  settings.dailyNoShowList.currentPage = pageNumber
}

function _init() {
  // do nothing
}

_init()

export default {
  getDailyNoShowDataFromServer: _getDailyNoShowDataFromServer,
  getDailyNoShowData: _getDailyNoShowData,
  getDailyNoShowDataSync: _getDailyNoShowDataSync,
  getDailyNoShowFiltersFromServer: _getDailyNoShowFiltersFromServer,
  getDailyNoShowFilters: _getDailyNoShowFilters,
  getDailyNoShowFiltersSync: _getDailyNoShowFiltersSync,

  getNumPerPage: getNumPerPage,
  getCurrentPage: getCurrentPage,
  setCurrentPage: setCurrentPage,
}
